const lp = './img/';
const plp = 'https://via.placeholder.com/350x250/';
export const imagesAssests = [
  lp + 'team1.jpg',
  lp + 'team2.jpg',
  lp + 'team3.jpg',
  lp + 'work-desk.jpg',
  lp + 'phone-app.png',
  lp + 'bg-gr-v.png',
  plp + '78c5d6/fff',
  plp + '459ba8/fff',
  plp + '79c267/fff',
  plp + 'c5d647/fff',
  plp + 'f28c33/fff',
  plp + 'e868a2/fff',
  plp + 'cc4360/fff',
];

export const commonMedia = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M16.725 19.5q-.3-.125-.563-.263t-.537-.337l-1.075.325q-.175.05-.325-.013t-.25-.212l-.6-1q-.1-.15-.05-.325t.175-.3l.825-.725q-.05-.3-.05-.65t.05-.65l-.825-.725q-.125-.125-.175-.3t.05-.325l.6-1q.1-.15.25-.212t.325-.013l1.075.325q.275-.2.537-.337t.563-.263l.225-1.1q.05-.175.163-.288t.312-.112h1.2q.2 0 .313.113t.162.287l.225 1.1q.3.125.563.263t.537.337l1.075-.325q.175-.05.325.013t.25.212l.6 1q.1.15.05.325t-.175.3l-.825.725q.05.3.05.65t-.05.65l.825.725q.125.125.175.3t-.05.325l-.6 1q-.1.15-.25.213t-.325.012l-1.075-.325q-.275.2-.537.338t-.563.262l-.225 1.1q-.05.175-.163.288t-.312.112h-1.2q-.2 0-.313-.113t-.162-.287l-.225-1.1Zm1.3-1.5q.825 0 1.413-.588T20.025 16q0-.825-.587-1.413T18.025 14q-.825 0-1.412.588T16.024 16q0 .825.588 1.413t1.412.587ZM5 20q-.825 0-1.412-.588T3 18V4q0-.825.588-1.413T5 2h14q.825 0 1.413.588T21 4v5.65q-.475-.225-.975-.363T19 9.075V4H5v9h3.55q.3 0 .525.138t.35.362q.35.575.775.9t.925.475q-.225 1.35.063 2.675T12.275 20H5Z"/></svg>';
export const spanSVG = '<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.0578 47L26.2046 68.8974H23.5869L31.4539 47H34.0578ZM44.5288 62.207C44.695 62.4748 44.7781 62.7749 44.7781 63.1073C44.7781 63.4674 44.6719 63.7906 44.4595 64.0768C44.2472 64.3538 43.9378 64.5754 43.5316 64.7416C43.1253 64.8986 42.6221 64.9771 42.0219 64.9771C41.5233 64.9771 41.0385 64.8986 40.5676 64.7416C40.1059 64.5754 39.7181 64.3123 39.4042 63.9522C39.0994 63.5828 38.9286 63.0888 38.8917 62.4702H35.6646C35.6646 63.292 35.9046 64.0861 36.3848 64.8524C36.8741 65.6096 37.5898 66.2329 38.5316 66.7222C39.4734 67.2024 40.623 67.4425 41.9803 67.4425C42.9037 67.4425 43.7347 67.3317 44.4734 67.1101C45.2213 66.8884 45.863 66.5791 46.3986 66.1821C46.9341 65.7758 47.3404 65.3003 47.6174 64.7555C47.9037 64.2015 48.0468 63.5921 48.0468 62.9272C48.0468 62.0316 47.8252 61.2929 47.382 60.7112C46.9388 60.1202 46.3016 59.6401 45.4706 59.2707C44.6488 58.8922 43.6655 58.5828 42.5205 58.3428C41.9111 58.2135 41.4032 58.0796 40.9969 57.9411C40.5999 57.8026 40.286 57.6549 40.0551 57.4979C39.8243 57.3317 39.6581 57.1516 39.5565 56.9577C39.4642 56.7546 39.418 56.5284 39.418 56.2791C39.418 55.9374 39.5057 55.6235 39.6812 55.3372C39.8658 55.051 40.1428 54.8202 40.5122 54.6447C40.8908 54.46 41.3663 54.3677 41.9388 54.3677C42.539 54.3677 43.0376 54.4785 43.4346 54.7001C43.8317 54.9125 44.1271 55.1941 44.321 55.545C44.5242 55.8866 44.6257 56.256 44.6257 56.653H47.9637C47.9637 55.7574 47.7236 54.954 47.2435 54.2431C46.7633 53.5228 46.0708 52.955 45.1659 52.5395C44.2702 52.1147 43.1945 51.9023 41.9388 51.9023C41.0523 51.9023 40.249 52.0224 39.5288 52.2625C38.8178 52.5025 38.213 52.8303 37.7144 53.2458C37.2158 53.6613 36.8326 54.1415 36.5648 54.6863C36.2971 55.2311 36.1632 55.8081 36.1632 56.4176C36.1632 57.0454 36.2924 57.5995 36.551 58.0796C36.8095 58.5598 37.1742 58.9753 37.6452 59.3261C38.1161 59.677 38.6793 59.9771 39.3349 60.2264C39.9997 60.4665 40.7292 60.6742 41.5233 60.8497C42.4282 61.0344 43.1114 61.2375 43.5731 61.4591C44.044 61.6807 44.3626 61.93 44.5288 62.207ZM54.3213 72.9272V65.7708C54.7478 66.2544 55.2464 66.6408 55.8172 66.93C56.5189 67.2716 57.3361 67.4425 58.2687 67.4425C59.2105 67.4425 60.0415 67.2532 60.7618 66.8746C61.482 66.496 62.0868 65.9651 62.5762 65.2818C63.0748 64.5893 63.4487 63.7813 63.698 62.858C63.9566 61.9254 64.0859 60.9143 64.0859 59.8248V59.5339C64.0859 58.3889 63.9612 57.3502 63.7119 56.4176C63.4626 55.4757 63.0886 54.6724 62.59 54.0076C62.0914 53.3335 61.4774 52.8165 60.7479 52.4564C60.0185 52.087 59.1828 51.9023 58.241 51.9023C57.3176 51.9023 56.5097 52.0778 55.8172 52.4287C55.1918 52.7455 54.653 53.1829 54.2008 53.7407L54.0582 52.1794H50.9834V72.9272H54.3213ZM55.4571 64.2984C54.9677 63.966 54.5891 63.5228 54.3213 62.9688V56.3754C54.4431 56.1342 54.5862 55.9128 54.7507 55.7112C55.0369 55.3603 55.3924 55.0879 55.8172 54.894C56.2419 54.6909 56.7498 54.5893 57.3407 54.5893C57.9409 54.5893 58.4534 54.7186 58.8781 54.9771C59.3121 55.2264 59.6676 55.5773 59.9446 56.0298C60.2216 56.4822 60.4247 57.0085 60.554 57.6087C60.6833 58.1996 60.7479 58.8414 60.7479 59.5339V59.8248C60.7479 60.4988 60.6833 61.1359 60.554 61.7361C60.4247 62.3363 60.2216 62.8672 59.9446 63.3289C59.6768 63.7813 59.3306 64.1368 58.9058 64.3954C58.4811 64.6539 57.9686 64.7832 57.3684 64.7832C56.5928 64.7832 55.9557 64.6216 55.4571 64.2984ZM75.4832 65.6863C75.3509 65.8308 75.2083 65.9729 75.0554 66.1128C74.6307 66.5006 74.1182 66.8192 73.518 67.0685C72.9271 67.3178 72.2438 67.4425 71.4682 67.4425C70.4894 67.4425 69.6168 67.2486 68.8504 66.8607C68.0841 66.4637 67.4839 65.9328 67.0499 65.268C66.6159 64.5939 66.3989 63.8321 66.3989 62.9826C66.3989 62.1886 66.5467 61.4868 66.8421 60.8774C67.1468 60.2587 67.5901 59.7417 68.1718 59.3261C68.7627 58.9106 69.4829 58.5967 70.3324 58.3843C71.1819 58.1627 72.1514 58.0519 73.241 58.0519H75.374V57.0131C75.374 56.4776 75.277 56.0159 75.0831 55.6281C74.8892 55.2403 74.5937 54.9402 74.1967 54.7278C73.8089 54.5154 73.3195 54.4093 72.7285 54.4093C72.1838 54.4093 71.7129 54.5016 71.3158 54.6863C70.9188 54.8709 70.6094 55.1202 70.3878 55.4342C70.1662 55.7481 70.0554 56.1036 70.0554 56.5007H66.7313C66.7313 55.9097 66.8745 55.3372 67.1607 54.7832C67.4469 54.2292 67.8624 53.7352 68.4072 53.3012C68.952 52.8673 69.603 52.5256 70.3601 52.2763C71.1173 52.027 71.9668 51.9023 72.9086 51.9023C74.0351 51.9023 75.0323 52.0916 75.9003 52.4702C76.7775 52.8488 77.4654 53.4213 77.964 54.1877C78.4718 54.9448 78.7258 55.8959 78.7258 57.0408V63.7029C78.7258 64.3861 78.7719 65.0002 78.8643 65.545C78.9658 66.0805 79.109 66.5468 79.2936 66.9438V67.1655H75.8726C75.7156 66.8053 75.591 66.3483 75.4986 65.7943C75.4933 65.7582 75.4881 65.7222 75.4832 65.6863ZM75.374 62.9349C75.3063 63.0683 75.2232 63.2042 75.1247 63.3428C74.8292 63.749 74.4229 64.0953 73.9058 64.3815C73.398 64.6585 72.8024 64.797 72.1191 64.797C71.6113 64.797 71.1773 64.7047 70.8172 64.52C70.4663 64.3354 70.1985 64.0814 70.0139 63.7583C69.8292 63.4259 69.7369 63.0611 69.7369 62.6641C69.7369 62.267 69.8153 61.9115 69.9723 61.5976C70.1293 61.2837 70.3647 61.0159 70.6787 60.7943C70.9926 60.5727 71.3851 60.4065 71.856 60.2957C72.3269 60.1756 72.8717 60.1156 73.4903 60.1156H75.374V62.9349ZM85.5259 67.1655V56.5152C85.6327 56.3087 85.7528 56.1146 85.886 55.9328C86.2 55.5173 86.5832 55.1895 87.0356 54.9494C87.4881 54.7094 88.0005 54.5893 88.573 54.5893C89.1547 54.5893 89.6395 54.6817 90.0273 54.8663C90.4243 55.0418 90.7244 55.3419 90.9276 55.7666C91.1399 56.1821 91.2461 56.75 91.2461 57.4702V67.1655H94.5979V57.484C94.5979 56.4591 94.4871 55.5958 94.2655 54.894C94.0439 54.183 93.7207 53.6059 93.296 53.1627C92.8805 52.7195 92.3773 52.401 91.7863 52.2071C91.2046 52.0039 90.5536 51.9023 89.8334 51.9023C88.9377 51.9023 88.1252 52.0778 87.3957 52.4287C86.6663 52.7703 86.0384 53.2597 85.5121 53.8968C85.4883 53.9261 85.4648 53.9556 85.4415 53.9854L85.332 52.1794H82.188V67.1655H85.5259ZM110 59.6841V59.2409V57.5096V57.0526L98.0337 51.9141V55.1412L106.632 58.3482L98.0337 61.6093V64.8365L110 59.6841ZM10 57.5272V57.0701L21.6759 51.9316V55.2003L13.4183 58.4109L21.6759 61.5715V64.854L10 59.7017V59.2446V57.5272Z" fill="#898989"/></svg>';


export const styleManagerConfig = {
  sectors: [
    {
      name: 'Cài đặt hệ thống nâng cao',
      id: 'advanced-setting',
      visible: false,
      properties: [
        {
          type: 'advanced-setting-info',
          key: 'advanced-setting-info',
          name: 'Thông tin',
          property: 'info',
          options: [
            {
              id: 'advanced-setting-id',
              name: 'Id',
              value: ''
            },
            {
              id: 'advanced-setting-title',
              name: 'Tiêu đề',
              value: ''
            },
          ],
        },
        {
          type: 'advanced-setting-display-subject',
          key: 'advanced-setting-display-subject',
          name: 'Đối tượng hiển thị',
          property: 'display-for',
          options: [
            {
              id: 'all',
              name: 'Tất cả',
            },
            {
              id: 'registered_only',
              name: 'Chỉ hiển thị với người dùng đã ghi danh',
            },
            {
              id: 'hidden',
              name: 'Không hiển thị',
            },
          ],
        },
        {
          type: 'advanced-setting-identification-card',
          key: 'advanced-setting-identification-card',
          name: 'Thẻ định danh',
          property: 'identification-card',
          options: [
            {
              id: 'advanced-setting-identification-card',
              name: 'Tên',
            },
          ],
        },
        {
          type: 'advanced-setting-replace',
          key: 'advanced-setting-replace',
          name: 'Thay thế bởi',
          property: 'replace',
        },
      ]
    },
    {
      name: 'General',
      properties: [
        {
          extend: 'float',
          type: 'radio',
          default: 'none',
          options: [
            { id: 'none', value: 'none', className: 'fa fa-times' },
            { id: 'left', value: 'left', className: 'fa fa-align-left' },
            { id: 'right', value: 'right', className: 'fa fa-align-right' },
          ],
        },
        'display',
        { extend: 'position', type: 'select' },
        'top',
        'right',
        'left',
        'bottom',
      ],
    },
    {
      name: 'Dimension',
      open: false,
      properties: [
        'width',
        {
          id: 'flex-width',
          type: 'integer',
          name: 'Width',
          units: ['px', '%'],
          property: 'flex-basis',
          toRequire: true,
        },
        'height',
        'max-width',
        'min-height',
        'margin',
        'padding',
      ],
    },
    {
      name: 'Typography',
      open: false,
      properties: [
        {
          name: 'Font Family',
          property: 'font-family',
          defaults: 'Arial, Helvetica, sans-serif',
          type: 'select',
          list: [
            { value: 'Arial, Helvetica, sans-serif', name: 'Arial' },
            { value: 'Courier New, Courier, monospace', name: 'Courier New' },
            { value: 'Helvetica, sans-serif', name: 'Helvetica' },
            { value: 'Tahoma, Geneva, sans-serif', name: 'Tahoma' },
            { value: 'Times New Roman, Times, serif', name: 'Times New Roman' },
            { value: 'Trebuchet MS, Helvetica, sans-serif', name: 'Trebuchet MS' },
            { value: 'Verdana, Geneva, sans-serif', name: 'Verdana' },
            { value: 'Verdana, Geneva, sans-serif', name: 'Verdana' },
          ],
        },
        {
          name: 'Font Size',
          type: 'font-size-custom',
          property: 'font-size',
          default: '',
          units: ['px', '%', 'rem', 'em'],
          min: 0,
          max: 1000,
        },
        {
          name: 'Font Weight',
          property: 'font-weight',
          defaults: '400',
          type: 'select',
          list: [
            { id: '400', value: '400', name: 'Nomal' },
            { id: '700', value: '700', name: 'Bold' },
            { id: '900', value: '900', name: 'Ultra-Bold' },
          ],
        },
        'letter-spacing',
        'color',
        'line-height',
        {
          extend: 'text-align',
          options: [
            {
              id: 'left',
              label: 'Left',
              className: 'fa fa-align-left',
            },
            {
              id: 'center',
              label: 'Center',
              className: 'fa fa-align-center',
            },
            {
              id: 'right',
              label: 'Right',
              className: 'fa fa-align-right',
            },
            {
              id: 'justify',
              label: 'Justify',
              className: 'fa fa-align-justify',
            },
          ],
        },

        {
          property: 'text-decoration',
          type: 'radio',
          default: 'none',
          options: [
            { id: 'none', label: 'None', className: 'fa fa-times' },
            {
              id: 'underline',
              label: 'underline',
              className: 'fa fa-underline',
            },
            {
              id: 'line-through',
              label: 'Line-through',
              className: 'fa fa-strikethrough',
            },
          ],
        },
        'text-shadow',
      ],
    },
    {
      name: 'Decorations',
      open: false,
      properties: [
        'opacity',
        'border-radius',
        'border',
        'box-shadow',
        'background', // { id: 'background-bg', property: 'background', type: 'bg' }
      ],
    },
    {
      name: 'Extra',
      open: false,
      buildProps: ['transition', 'perspective', 'transform'],
    },
    {
      name: 'Flex',
      open: false,
      properties: [
        {
          name: 'Flex Container',
          property: 'display',
          type: 'select',
          defaults: 'block',
          list: [
            { id: 'block', value: 'block', name: 'Disable' },
            { id: 'flex', value: 'flex', name: 'Enable' },
          ],
        },
        {
          name: 'Flex Parent',
          property: 'label-parent-flex',
          type: 'integer',
        },
        {
          name: 'Direction',
          property: 'flex-direction',
          type: 'radio',
          defaults: 'row',
          list: [
            {
              id: 'row',
              value: 'row',
              name: 'Row',
              className: 'icons-flex icon-dir-row',
              title: 'Row',
            },
            {
              id: 'row-reverse',
              value: 'row-reverse',
              name: 'Row reverse',
              className: 'icons-flex icon-dir-row-rev',
              title: 'Row reverse',
            },
            {
              id: 'column',
              value: 'column',
              name: 'Column',
              title: 'Column',
              className: 'icons-flex icon-dir-col',
            },
            {
              id: 'column-reverse',
              value: 'column-reverse',
              name: 'Column reverse',
              title: 'Column reverse',
              className: 'icons-flex icon-dir-col-rev',
            },
          ],
        },
        {
          name: 'Justify',
          property: 'justify-content',
          type: 'radio',
          defaults: 'flex-start',
          list: [
            {
              id: 'flex-start',
              value: 'flex-start',
              className: 'icons-flex icon-just-start',
              title: 'Start',
            },
            {
              id: 'flex-end',
              value: 'flex-end',
              title: 'End',
              className: 'icons-flex icon-just-end',
            },
            {
              id: 'space-between',
              value: 'space-between',
              title: 'Space between',
              className: 'icons-flex icon-just-sp-bet',
            },
            {
              id: 'space-around',
              value: 'space-around',
              title: 'Space around',
              className: 'icons-flex icon-just-sp-ar',
            },
            {
              id: 'center',
              value: 'center',
              title: 'Center',
              className: 'icons-flex icon-just-sp-cent',
            },
          ],
        },
        {
          name: 'Align',
          property: 'align-items',
          type: 'radio',
          defaults: 'center',
          list: [
            {
              id: 'flex-start',
              value: 'flex-start',
              title: 'Start',
              className: 'icons-flex icon-al-start',
            },
            {
              id: 'flex-end',
              value: 'flex-end',
              title: 'End',
              className: 'icons-flex icon-al-end',
            },
            {
              id: 'stretch',
              value: 'stretch',
              title: 'Stretch',
              className: 'icons-flex icon-al-str',
            },
            {
              id: 'center',
              value: 'center',
              title: 'Center',
              className: 'icons-flex icon-al-center',
            },
          ],
        },
        {
          name: 'Flex Children',
          property: 'label-parent-flex',
          type: 'integer',
        },
        {
          name: 'Order',
          property: 'order',
          type: 'integer',
          defaults: '0',
          min: 0,
        },
        {
          name: 'Flex',
          property: 'flex',
          type: 'composite',
          properties: [
            {
              name: 'Grow',
              property: 'flex-grow',
              type: 'integer',
              defaults: '0',
              min: 0,
            },
            {
              name: 'Shrink',
              property: 'flex-shrink',
              type: 'integer',
              defaults: '0',
              min: 0,
            },
            {
              name: 'Basis',
              property: 'flex-basis',
              type: 'integer',
              units: ['px', '%', ''],
              unit: '',
              defaults: 'auto',
            },
          ],
        },
        {
          name: 'Align',
          property: 'align-self',
          type: 'radio',
          defaults: 'auto',
          list: [
            {
              id: 'auto',
              value: 'auto',
              name: 'Auto',
            },
            {
              id: 'flex-start',
              value: 'flex-start',
              title: 'Start',
              className: 'icons-flex icon-al-start',
            },
            {
              id: 'flex-end',
              value: 'flex-end',
              title: 'End',
              className: 'icons-flex icon-al-end',
            },
            {
              id: 'stretch',
              value: 'stretch',
              title: 'Stretch',
              className: 'icons-flex icon-al-str',
            },
            {
              id: 'center',
              value: 'center',
              title: 'Center',
              className: 'icons-flex icon-al-center',
            },
          ],
        },
      ],
    },
  ],
};

export const styleManagerCertificate = {
  sectors: [
    {
      name: 'General',
      properties: [
        {
          extend: 'float',
          type: 'radio',
          default: 'none',
          options: [
            { id: 'none', value: 'none', className: 'fa fa-times' },
            { id: 'left', value: 'left', className: 'fa fa-align-left' },
            { id: 'right', value: 'right', className: 'fa fa-align-right' },
          ],
        },
        'display',
        { extend: 'position', type: 'select' },
        'top',
        'right',
        'left',
        'bottom',
      ],
    },
    {
      name: 'Dimension',
      open: false,
      properties: [
        'width',
        {
          id: 'flex-width',
          type: 'integer',
          name: 'Width',
          units: ['px', '%'],
          property: 'flex-basis',
          toRequire: true,
        },
        'height',
        'max-width',
        'min-height',
        'margin',
        'padding',
      ],
    },
    {
      name: 'Typography',
      open: true,
      properties: [
        'font-family',
        'font-size',
        'font-weight',
        'letter-spacing',
        'color',
        'line-height',
        {
          extend: 'text-align',
          options: [
            {
              id: 'left',
              label: 'Left',
              className: 'fa fa-align-left',
            },
            {
              id: 'center',
              label: 'Center',
              className: 'fa fa-align-center',
            },
            {
              id: 'right',
              label: 'Right',
              className: 'fa fa-align-right',
            },
            {
              id: 'justify',
              label: 'Justify',
              className: 'fa fa-align-justify',
            },
          ],
        },
        {
          property: 'text-decoration',
          type: 'radio',
          default: 'none',
          options: [
            { id: 'none', label: 'None', className: 'fa fa-times' },
            {
              id: 'underline',
              label: 'underline',
              className: 'fa fa-underline',
            },
            {
              id: 'line-through',
              label: 'Line-through',
              className: 'fa fa-strikethrough',
            },
          ],
        },
        'text-shadow',
      ],
    },
  ],
};
